import { render, staticRenderFns } from "./details-info.vue?vue&type=template&id=a6642432"
import script from "./details-info.vue?vue&type=script&lang=js"
export * from "./details-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6642432')) {
      api.createRecord('a6642432', component.options)
    } else {
      api.reload('a6642432', component.options)
    }
    module.hot.accept("./details-info.vue?vue&type=template&id=a6642432", function () {
      api.rerender('a6642432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deviceInfo-manage/device/details-info.vue"
export default component.exports